import uk from './uk';
import en from './en';
import fr from './fr';
import es from './es';
import it from './it';
import pl from './pl';

const languages = { uk, en, fr, es, it, pl };

export const LANGUAGE_LIST = Object.entries(languages).map(([code, dict]) => ({
  code,
  name: dict._name,
  flag: dict._flag,
}));

export default languages;
